import React, { useState } from 'react';
import { Panel, PanelTheme, MultilineTextBox, MultilineTextBoxLayoutStyle } from '@apply/components';
import { DemoSection } from './common/SectionNavigator';
import { DemoPage, DemoPageSection } from './common/DemoLayout';

const sections: DemoSection[] = [
    { id: 'multilineTextBoxDemo_vertical', title: 'Vertical' },
    { id: 'multilineTextBoxDemo_horizontal', title: 'Horizontal' },
];

export const MultilineTextBoxDemo: React.FC = () => {
    // State for each example
    const [basicValue, setBasicValue] = useState('');
    const [readOnlyValue, setReadOnlyValue] = useState('Read only value');
    const [requiredValue, setRequiredValue] = useState('');
    const [basicValueWithBubble, setBasicValueWithBubble] = useState('');
    const [horizontalBasicValue, setHorizontalBasicValue] = useState('');
    const [horizontalReadOnlyValue, setHorizontalReadOnlyValue] = useState('Read only value');
    const [horizontalRequiredValue, setHorizontalRequiredValue] = useState('');
    const [horizontalBasicValueWithBubble, setHorizontalBasicValueWithBubble] = useState('');

    return (
        <DemoPage
            title='Multiline Text Box :'
            sections={sections}
        >
            <DemoPageSection
                id={sections[0].id}
                title={sections[0].title}
            >
                <Panel theme={PanelTheme.White}>
                    <div style={{ padding: '1rem' }}>
                        {/* Example 1: Basic Multiline Textbox */}
                        <div style={{ marginBottom: '1rem' }}>
                            <MultilineTextBox
                                value={basicValue}
                                onChange={setBasicValue}
                                label='Basic MultilineBox'
                            />
                        </div>

                        {/* Example 2: Read-Only Multiline Textbox */}
                        <div style={{ marginBottom: '1rem' }}>
                            <MultilineTextBox
                                value={readOnlyValue}
                                onChange={setReadOnlyValue}
                                label='Read-Only MultilineBox'
                                readOnly={true}
                            />
                        </div>

                        {/* Example 3: Required Field */}
                        <div style={{ marginBottom: '1rem' }}>
                            <MultilineTextBox
                                value={requiredValue}
                                onChange={setRequiredValue}
                                label='Required MultilineBox'
                                required={true}
                            />
                        </div>

                        {/* Example 4: Basic Multiline Textbox */}
                        <div style={{ marginBottom: '1rem' }}>
                            <MultilineTextBox
                                value={basicValueWithBubble}
                                onChange={setBasicValueWithBubble}
                                label='Basic MultilineBox With Bubble'
                                showInfoIcon={true}
                                infoText='Basic MultilineBox With Bubble'
                            />
                        </div>
                    </div>
                </Panel>
            </DemoPageSection>
            <DemoPageSection
                id={sections[1].id}
                title={sections[1].title}
            >
                <Panel theme={PanelTheme.White}>
                    <div style={{ padding: '1rem' }}>
                        {/* Example 5: Basic Multiline Textbox (Horiz.) */}
                        <div style={{ marginBottom: '1rem' }}>
                            <MultilineTextBox
                                value={horizontalBasicValue}
                                onChange={setHorizontalBasicValue}
                                label='Basic MultilineBox (Horiz.)'
                                layoutStyle={MultilineTextBoxLayoutStyle.Horizontal}
                                labelWidth='300px'
                            />
                        </div>

                        {/* Example 6: Read-Only Multiline Textbox (Horiz.) */}
                        <div style={{ marginBottom: '1rem' }}>
                            <MultilineTextBox
                                value={horizontalReadOnlyValue}
                                onChange={setHorizontalReadOnlyValue}
                                label='Read-Only MultilineBox (Horiz.)'
                                readOnly={true}
                                layoutStyle={MultilineTextBoxLayoutStyle.Horizontal}
                                labelWidth='300px'
                            />
                        </div>

                        {/* Example 7: Required Field (Horiz.) */}
                        <div style={{ marginBottom: '1rem' }}>
                            <MultilineTextBox
                                value={horizontalRequiredValue}
                                onChange={setHorizontalRequiredValue}
                                label='Required MultilineBox (Horiz.)'
                                required={true}
                                layoutStyle={MultilineTextBoxLayoutStyle.Horizontal}
                                labelWidth='300px'
                            />
                        </div>

                        {/* Example 8: Basic Multiline Textbox With Bubble (Horiz.) */}
                        <div style={{ marginBottom: '1rem' }}>
                            <MultilineTextBox
                                value={horizontalBasicValueWithBubble}
                                onChange={setHorizontalBasicValueWithBubble}
                                label='Basic MultilineBox With Bubble (Horiz.)'
                                showInfoIcon={true}
                                infoText='Basic MultilineBox With Bubble'
                                layoutStyle={MultilineTextBoxLayoutStyle.Horizontal}
                                labelWidth='300px'
                            />
                        </div>
                    </div>
                </Panel>
            </DemoPageSection>
        </DemoPage>
    );
};
